import DataRoomMemberInfo from './DataRoomMemberInfo.component';

export default DataRoomMemberInfo;
